import { render, staticRenderFns } from "./IllegallyInquiry.vue?vue&type=template&id=6d75f8f6&scoped=true&"
import script from "./IllegallyInquiry.vue?vue&type=script&lang=js&"
export * from "./IllegallyInquiry.vue?vue&type=script&lang=js&"
import style0 from "./IllegallyInquiry.vue?vue&type=style&index=0&id=6d75f8f6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d75f8f6",
  null
  
)

export default component.exports